import * as React from "react"
export const Svg_029 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={59}
    fill="none"
  >
    <g clipPath="url(#a)">
      <path
        fill="url(#b)"
        d="M1.637 46.89.004 58.992l11.898-1.661.031-.032L1.67 46.857l-.032.032Z"
      />
      <path
        fill="url(#c)"
        d="m8.872 39.523 8.394-8.539 10.263 10.44-8.394 8.539-10.263-10.44Z"
      />
      <path
        fill="url(#d)"
        d="m4.066 44.41 2.402-2.444 10.264 10.44-2.403 2.444L4.066 44.41Z"
      />
      <path
        fill="url(#e)"
        d="m40.04 7.823 2.403-2.444 10.263 10.44-2.402 2.443L40.04 7.822Z"
      />
      <path
        fill="url(#f)"
        d="m30.45 17.577 7.188-7.311L47.9 20.706l-7.188 7.311-10.263-10.44Z"
      />
      <path
        fill="url(#g)"
        d="M55.87 12.604a7.399 7.399 0 0 0 2.126-5.22 7.4 7.4 0 0 0-2.126-5.221A7.15 7.15 0 0 0 50.738 0a7.149 7.149 0 0 0-5.132 2.163l-.755.767 10.265 10.442.754-.768Z"
      />
      <path
        fill="url(#h)"
        d="M45.928 44.502c-.56 0-1.12.216-1.546.65a2.254 2.254 0 0 0 0 3.145c.852.867 2.24.867 3.092 0a2.254 2.254 0 0 0 0-3.145 2.16 2.16 0 0 0-1.546-.65Z"
      />
      <path
        fill="url(#i)"
        d="M23.707 15.599c1.161-4.236.005-8.834-3.09-11.983C16.98-.082 11.432-1.032 6.81 1.252l-.529.262 7.42 7.547-4.802 4.884L1.48 6.4l-.257.54c-2.242 4.7-1.307 10.342 2.326 14.038a11.977 11.977 0 0 0 8.544 3.594c1.082 0 2.17-.148 3.236-.45l18.974 19.301c-1.162 4.236-.005 8.834 3.09 11.983 2.28 2.318 5.31 3.595 8.534 3.595 3.223 0 6.253-1.277 8.532-3.596 2.28-2.318 3.535-5.4 3.535-8.68 0-3.278-1.255-6.361-3.535-8.68A11.947 11.947 0 0 0 42.681 34.9L23.707 15.599Zm26.17 35.142a5.519 5.519 0 0 1-3.95 1.661c-1.43 0-2.86-.553-3.948-1.66-2.177-2.216-2.177-5.82 0-8.034a5.524 5.524 0 0 1 7.898 0c2.177 2.215 2.177 5.818 0 8.033Z"
      />
    </g>
    <defs>
      <linearGradient
        id="b"
        x1={2.762}
        x2={8.57}
        y1={48.678}
        y2={57.918}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={12.353}
        x2={24.544}
        y1={39.114}
        y2={40.784}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={6.161}
        x2={11.169}
        y1={45.411}
        y2={43.193}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={42.136}
        x2={47.144}
        y1={8.823}
        y2={6.605}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={33.652}
        x2={45.192}
        y1={17.453}
        y2={18.162}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={47.891}
        x2={54.291}
        y1={2.006}
        y2={12.187}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={44.753}
        x2={46.881}
        y1={45.168}
        y2={48.554}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="i"
        x1={13.423}
        x2={41.65}
        y1={8.867}
        y2={53.776}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h58v59H0z" />
      </clipPath>
    </defs>
  </svg>
)